import { Dialog, Transition } from "@headlessui/react";
import * as htmlToImage from "html-to-image";
import moment from "moment";
import { Fragment, useEffect, useRef, useState } from "react";
import CurrencyInput from "react-currency-input-field";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { BottomSheet } from "react-spring-bottom-sheet";
import "react-spring-bottom-sheet/dist/style.css";
import dotBalance from "../../assets/images/icon_home/dot-balance.svg";
import paymentSuccess from "../../assets/images/icon_invoice/payment-success.svg";
import { isDarkColor } from "../../config/DarkColorChecker";
import { formatCurrency } from "../../config/global";
import { downloadBase64 } from "../../config/iosBridge";
import { setLoading } from "../../core/feature/config/configSlice";
import { useAppDispatch, useAppSelector } from "../../core/feature/hooks";
import CustomApp from "../../core/models/customApp";
import User from "../../core/models/user";
import { invoicePayment } from "../../core/service/api_invoice";
import useAnalyticsEventTracker from "../../core/service/useAnalyticsEventTracker";
import TabsMobile from "../__template/TabsMobileComponent";

const ComponentInvoiceCreditPayment = () => {
  const gaEventTracker = useAnalyticsEventTracker("Transaction");
  const customApp: CustomApp = useAppSelector(
    (state) => state.customApp.customApp,
  );
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const ref = useRef<HTMLDivElement>(null);
  const [data, setData] = useState<any>({});
  const [amount, setAmount] = useState<any>(0);
  const user: User = useAppSelector((state) => state.user.user);
  const [selectedItems, setSelectedItems] = useState<any>([]);
  const nominalList = [100000, 200000, 300000, 500000];
  const balance = localStorage.getItem("balance_redux");
  const location = useLocation();
  const detail = location.state?.data.detail;
  const invoiceId = location.state?.data.invoiceId;
  const [minimumPayment, setMinimumPayment] = useState<any>(0);
  const minimumPaymentType = location.state?.data.minimumPaymentType;
  const minimumPaymentPosition = location.state?.data.minimumPaymentPosition;
  const unpaidAmount =
    location.state?.data.detail.reduce(
      (acc: number, curr: any) =>
        acc + (curr.amount || 0) - (curr.discount || 0),
      0,
    ) - location.state?.data.paidAmount;
  const [openPaymentSuccessInvoice, setOpenPaymentSuccessInvoice] =
    useState(false);
  const [detailPaymentSuccess, setDetailPaymentSuccess] = useState<any>({});
  const [tempPaymentList, setTempPaymentList] = useState<any>([]);
  const [totalPayment, setTotalPayment] = useState<any>(0);
  const [tempAmount, setTempAmount] = useState<any>(0);
  const [invoiceToPay, setInvoiceToPay] = useState<any>({});
  const [mustPaidOff, setMustPaidOff] = useState(false);
  const invoiceFeature = JSON.parse(localStorage.getItem("invoice-feature")!);

  const [url, setUrl] = useState<string>("none"); // Unfortunately, we have to have a dummy string here, or FacebookShareButton will blow up.

  let [isOpen, setIsOpen] = useState(false);
  let [isOpen2, setIsOpen2] = useState(false);
  const ref2 = useRef<HTMLDivElement>(null);
  var invoicea = `${t("INVOICE.title")}`;
  var history = `${t("INVOICE.history")}`;
  var summary = `${t("INVOICE.summary")}`;
  var placeholder = `${t("INVOICE.placeholder")}`;
  const id = useParams();

  const shareButton = useRef<HTMLButtonElement>(null);

  const closeCreate = () => {
    setIsOpen(false);
  };

  const closeCreate2 = () => {
    setIsOpen2(false);
  };

  function onDismissPaymentSuccessInvoice() {
    window.scrollTo(0, 0);
    setOpenPaymentSuccessInvoice(false);
    navigate("/invoice");
  }

  const downloadForm = async () => {
    dispatch(setLoading(true));
    // setShowDescription(false);
    // Be sure to check for the "none" state, so we don't trigger an infinite loop.
    if (url === "none") {
      if (ref.current === null) {
        return;
      }

      htmlToImage
        .toPng(ref.current, { cacheBust: true })
        .then((dataUrl) => {
          if (localStorage.getItem("device")?.includes("ios")) {
            downloadBase64(dataUrl);
            dispatch(setLoading(false));
            // setShowDescription(true);
          } else {
            var link = document.createElement("a");
            link.href = dataUrl;
            console.log(dataUrl, "sukses");
            var iframe =
              "<iframe width='100%' height='100%' src='" +
              dataUrl +
              "'></iframe>";

            const linkSource = dataUrl;
            const downloadLink = document.createElement("a");
            downloadLink.href = linkSource;
            downloadLink.download =
              detailPaymentSuccess.inquiryResponseDto?.title +
              " - " +
              detailPaymentSuccess.inquiryResponseDto?.customerName;
            downloadLink.click();

            dispatch(setLoading(false));
            // setShowDescription(true);
            // link.click();
          }
        })
        .catch((err) => {
          console.log(err);

          dispatch(setLoading(false));
          // setShowDescription(true);
        });
    }
  };

  const handleToggle = (item: any) => {
    const isSelected = selectedItems.find((i: any) => i.title === item.title);
    if (isSelected) {
      setSelectedItems(
        selectedItems.filter((i: any) => i.title !== item.title),
      );
    } else {
      setSelectedItems([...selectedItems, item]);
    }
  };

  const handleSubmit = () => {
    const invoiceCredits = tempPaymentList.map((prop: any) => {
      return {
        id: prop.id,
        title: prop.title,
        amount: parseInt(prop.amount),
        coaCode: prop.coaCode,
      };
    });

    let data = {
      invoiceId: invoiceId,
      amount: parseInt(totalPayment),
      channel: "MOBILE",
      cash: false,
      invoiceCredits: invoiceCredits,
    };

    dispatch(setLoading(true));
    invoicePayment(data)
      .then((res: any) => {
        setDetailPaymentSuccess(res.data);
        setOpenPaymentSuccessInvoice(true);
        dispatch(setLoading(false));
        setIsOpen2(false);
      })
      .catch((err: any) => {
        dispatch(setLoading(false));
      });
  };

  useEffect(() => {
    let minPayment = location.state?.data.minimumPayment;
    if (minimumPaymentType === "PERCENT") {
      let amount = invoiceToPay.amount;
      if (minimumPaymentPosition === "SUMMARY")
        amount = detail.reduce(
          (acc: number, curr: any) => acc + (curr.amount || 0),
          0,
        );
      minPayment = (minPayment / 100) * amount;
    }
    setMinimumPayment(minPayment);
  }, [isOpen]);

  useEffect(() => {
    setTotalPayment(
      tempPaymentList.reduce(
        (acc: number, curr: any) => acc + (curr.amount || 0),
        0,
      ),
    );
  }, [tempPaymentList]);

  useEffect(() => {
    let { minimumPayment, amount, paidAmount } = location.state?.data;
    if (minimumPaymentPosition === "SUMMARY") {
      let totalPayment = 0;
      if (amount - paidAmount < minimumPayment) {
        setTempPaymentList(
          detail.map((item: any) => {
            totalPayment += item.amount - item.discount - item.paidAmount;
            return {
              ...item,
              amount: item.amount - item.discount - item.paidAmount,
            };
          }),
        );
        setTempAmount(totalPayment);
        setMustPaidOff(true);
      }
    }
  }, []);

  return (
    <div className="min-h-screen h-full  bg-psp-primary">
      <div className="px-3 pt-4 pb-3  sticky top-0">
        <TabsMobile
          name={`${t("INVOICE.creditTitle")}`}
          backUrl={"home"}
        ></TabsMobile>
      </div>

      {/* ====================== SUCCESS BOTTOMSHEET ===================== */}
      <BottomSheet
        open={openPaymentSuccessInvoice}
        onDismiss={onDismissPaymentSuccessInvoice}
        defaultSnap={({ snapPoints, lastSnap }) =>
          lastSnap ?? Math.min(...snapPoints)
        }
        snapPoints={({ maxHeight }) => [
          maxHeight - maxHeight / 5,
          maxHeight * 0.8,
        ]}
        header={""}
        footer={
          <div className="flex flex-col gap-2 z-[1000]">
            {/* <button className="disabled:bg-psp-gray w-full bg-white shadow-lg  text-psp-primary  border-1 border-psp-primary border-solid py-2.5 text-sm font-semibold rounded-lg">
              {t("INVOICE.share")}
            </button> */}
            <button
              onClick={downloadForm}
              style={{ backgroundColor: customApp?.app_accent_color }}
              className={`disabled:bg-psp-gray w-full  shadow-lg py-2.5 text-sm font-semibold rounded-lg ${
                isDarkColor(customApp.app_accent_color)
                  ? "text-white"
                  : "text-black"
              }`}
            >
              {t("INVOICE.download")}
            </button>
            <button
              onClick={() => onDismissPaymentSuccessInvoice()}
              style={{ backgroundColor: customApp?.app_secondary_accent_color }}
              className={`disabled:bg-psp-gray w-full shadow-lg py-2.5 text-sm font-semibold rounded-lg ${
                isDarkColor(customApp.app_secondary_accent_color)
                  ? "text-white"
                  : "text-black"
              }`}
            >
              {t("OTHER.close")}
            </button>
          </div>
        }
      >
        <div className="px-4 py-2 bg-white" ref={ref}>
          <div className="flex flex-col items-center gap-1 mb-6">
            <img className="w-24 h-24 mb-1" src={paymentSuccess} alt="" />
            <h1 className="m-0 font-montserrat text-2xl font-medium">
              {t("INVOICE.success")}
            </h1>
            <span className="font-montserrat text-sm text-psp-nav font-light">
              {t("INVOICE.date")} :{" "}
              {moment(detailPaymentSuccess.dateTime).format("LLL")}
            </span>
          </div>
          <h1 className="font-poppins font-medium text-sm text-black my-2">
            {t("INVOICE.paymentData")}
          </h1>
          <div className="grid grid-cols-2 gap-1">
            <div className="flex flex-row">
              <h1 className="font-poppins font-normal text-sm text-psp-nav">
                {t("INVOICE.studentName")}
              </h1>
            </div>
            <div className="font-poppins font-normal text-sm text-psp-nav text-left flex flex-row gap-2 w-full">
              <div className="font-poppins grow text-right">
                {detailPaymentSuccess.inquiryResponseDto?.customerName}
              </div>
            </div>
          </div>
          <hr />
          <div>
            <h1 className="font-poppins font-medium text-sm text-black my-2">
              {t("INVOICE.detailInvoice")}
            </h1>
            <div className="grid grid-cols-2 gap-1">
              <div className="flex flex-row">
                <h1 className="font-poppins font-normal text-sm text-psp-nav">
                  {t("INVOICE.invoiceName")}
                </h1>
              </div>
              <div className="font-poppins font-normal text-sm text-psp-nav text-left flex flex-row gap-2">
                <div className="grow text-right">
                  {" "}
                  {detailPaymentSuccess.inquiryResponseDto?.title}
                </div>
              </div>
            </div>
            <div className="font-poppins grid grid-cols-2 gap-1">
              <div className="flex flex-row">
                <h1 className=" font-normal text-sm text-psp-nav">
                  {t("INVOICE.payDate")}
                </h1>
              </div>
              <div className="font-poppins font-normal text-sm text-psp-nav text-left flex flex-row gap-2 w-full">
                <div className="grow text-right">
                  {moment(detailPaymentSuccess.dateTime).format("LL")}
                </div>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-1">
              <div className="flex flex-row">
                <h1 className="font-poppins font-normal text-sm text-psp-nav">
                  {t("INVOICE.invoiceType")}
                </h1>
              </div>
              <div className="font-poppins font-normal text-sm text-psp-nav text-left flex flex-row gap-2 w-full">
                <div className="grow text-right">
                  {detailPaymentSuccess.inquiryResponseDto?.partialMethod ==
                  false
                    ? t("INVOICE.cash")
                    : t("INVOICE.credit")}
                </div>
              </div>
            </div>
            <div className="grid grid-cols-2 gap-1" hidden>
              <div className="flex flex-row">
                <h1 className="font-poppins font-normal text-sm text-psp-nav">
                  Status
                </h1>
              </div>
              <div className="font-poppins font-normal text-sm text-psp-hover text-left flex flex-row gap-2 w-full">
                <div className="grow text-right">
                  {/* {invoiceDetail?.status == "UNPAID"
                    ? t("INVOICE.unpaid")
                    : invoiceDetail?.status == "PAID"
                    ? t("INVOICE.paid")
                    : detailPaymentSuccess?.inquiryResponseDto?.amount -
                        (detailPaymentSuccess?.inquiryResponseDto?.paidAmount +
                          detailPaymentSuccess?.amount) ==
                      0
                    ? t("INVOICE.paid")
                    : t("INVOICE.partial")} */}
                </div>
              </div>
            </div>
            <div hidden={!detailPaymentSuccess?.inquiryResponseDto?.showDetail}>
              {detail?.map((res: any) => (
                <div className="grid grid-cols-2 gap-1">
                  <div className="flex flex-row">
                    <h1 className="font-poppins font-normal text-sm text-psp-nav">
                      {res.title}
                    </h1>
                  </div>
                  <div className="font-poppins font-normal text-sm text-psp-hover text-left flex flex-row gap-2 w-full">
                    <div className="flex flex-col grow text-right">
                      {res.discount > 0 && (
                        <span className="text-xs line-through">
                          {formatCurrency(res.amount)}
                        </span>
                      )}
                      <span>{formatCurrency(res.amount - res.discount)}</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <hr />
          <div className="grid grid-cols-2 gap-1">
            <div className="flex flex-row">
              <h1 className="font-poppins font-normal text-sm text-psp-nav">
                {t("INVOICE.total")}
              </h1>
            </div>
            <div className="font-poppins font-normal text-sm text-psp-hover text-left flex flex-row gap-2 w-full">
              <div className="grow text-right">
                {formatCurrency(
                  detailPaymentSuccess?.inquiryResponseDto?.amount,
                )}
              </div>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-1">
            <div className="flex flex-row">
              <h1 className="font-poppins font-normal text-sm text-psp-nav">
                {t("INVOICE.sisa")}
              </h1>
            </div>
            <div className="font-poppins font-normal text-sm text-psp-hover text-left flex flex-row gap-2 w-full">
              <div className="grow text-right">
                {formatCurrency(
                  detailPaymentSuccess?.inquiryResponseDto?.amount -
                    detailPaymentSuccess?.inquiryResponseDto?.paidAmount,
                )}
              </div>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-1">
            <div className="flex flex-row">
              <h1 className="font-poppins font-normal text-sm text-psp-nav">
                {t("INVOICE.totalpay")}
              </h1>
            </div>
            <div className="font-poppins font-normal text-sm text-psp-hover text-left flex flex-row gap-2 w-full">
              <div className="grow text-right">
                {formatCurrency(totalPayment)}
              </div>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-1">
            <div className="flex flex-row">
              <h1 className="font-poppins font-normal text-sm text-psp-nav">
                {t("INVOICE.minus")}
              </h1>
            </div>
            <div className="font-poppins font-normal text-sm text-rose-600 text-left flex flex-row gap-2 w-full">
              <div className="grow text-right">
                {formatCurrency(
                  detailPaymentSuccess?.inquiryResponseDto?.amount -
                    (detailPaymentSuccess?.inquiryResponseDto?.paidAmount +
                      detailPaymentSuccess?.amount),
                )}
              </div>
            </div>
          </div>
          <div className="flex flex-col items-center gap-2 mb-3"></div>
        </div>
      </BottomSheet>
      {/* ================================================================ */}

      {/* ====================== INPUT AMOUNT POPUP ===================== */}
      <Transition appear show={isOpen} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={closeCreate}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-25" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                  <Dialog.Title
                    as="h3"
                    className="text-lg font-medium leading-6 text-gray-900"
                  >
                    {t("INVOICE.inputAmount")}
                  </Dialog.Title>
                  <div className="mt-2">
                    <p className="text-xs text-gray-500 mb-0">
                      {t("INVOICE.detailInvoice")}:
                    </p>
                    <div className="mt-0">
                      <span className="font-montserrat m-0 text-xs font-normal ">
                        {tempPaymentList.length > 0
                          ? tempPaymentList[tempPaymentList.length - 1]?.title
                          : ""}
                      </span>
                    </div>
                  </div>
                  <div className="mt-2">
                    <p className="text-xs text-gray-500 mb-0">
                      {t("INVOICE.amountLabel")}:
                    </p>
                    <div className="mt-0">
                      {invoiceToPay.discount > 0 && (
                        <span className="font-montserrat m-0 mr-1 text-[10px] font-normal line-through">
                          {formatCurrency(invoiceToPay.amount)}
                        </span>
                      )}
                      <span className="font-montserrat m-0 text-xs font-normal text-red">
                        {formatCurrency(
                          invoiceToPay.amount -
                            invoiceToPay.discount -
                            invoiceToPay.paidAmount,
                        )}
                      </span>
                    </div>
                  </div>
                  <div className="mt-2">
                    <div className="text-center mt-2 flex items-center justify-center">
                      <CurrencyInput
                        placeholder={`>= ${
                          location.state?.data.minimumPayment === 0
                            ? 10000
                            : minimumPaymentPosition === "ITEM"
                              ? minimumPayment
                              : 0
                        }`}
                        decimalsLimit={2}
                        prefix={"Rp "}
                        className="px-3 grow rounded-lg h-10 border-1 border-psp-gray border-solid"
                        value={
                          tempPaymentList.length > 0
                            ? tempPaymentList[tempPaymentList.length - 1]
                                ?.amount || ""
                            : ""
                        }
                        onValueChange={(value) => {
                          // Update amount for the last item in tempPaymentList
                          setTempPaymentList((prev: any) => {
                            if (prev.length === 0) return prev;
                            const updated = [...prev];
                            updated[updated.length - 1] = {
                              ...updated[updated.length - 1],
                              amount: parseInt(value || "0"),
                            };
                            return updated;
                          });
                        }}
                      />
                    </div>
                  </div>
                  <div className="justify-center mt-4 flex gap-2">
                    <button
                      type="button"
                      style={{
                        backgroundColor: customApp?.app_secondary_accent_color,
                      }}
                      className={`inline-flex justify-center rounded-md border border-transparent  px-4 py-2 text-sm font-medium ${
                        isDarkColor(customApp.app_secondary_accent_color)
                          ? "text-white"
                          : "text-black"
                      }`}
                      onClick={() => {
                        console.log(tempPaymentList);

                        // Remove the last item from tempPaymentList
                        setTempPaymentList((prev: any) => prev.slice(0, -1));
                        closeCreate();
                      }}
                    >
                      {t("TOPUP.cancel")}
                    </button>
                    <button
                      type="button"
                      style={{
                        backgroundColor: customApp?.app_accent_color,
                      }}
                      className={`inline-flex justify-center rounded-md border border-transparent  px-4 py-2 text-sm font-medium ${
                        isDarkColor(customApp.app_accent_color)
                          ? "text-white"
                          : "text-black"
                      }`}
                      disabled={
                        tempPaymentList.length === 0 ||
                        parseInt(
                          tempPaymentList[tempPaymentList.length - 1]?.amount ||
                            0,
                        ) <= 0
                      }
                      onClick={() => {
                        const amount = parseInt(
                          tempPaymentList[tempPaymentList.length - 1]?.amount ||
                            0,
                        );
                        if (
                          minimumPaymentPosition === "SUMMARY" &&
                          location.state?.data.minimumPayment == 0 &&
                          totalPayment < 10000
                        ) {
                          alert(
                            `Amount must be at least ${formatCurrency(10000)}`,
                          );
                          return;
                        }
                        if (
                          minimumPaymentPosition === "ITEM" &&
                          amount < minimumPayment
                        ) {
                          alert(
                            `Amount must be at least ${formatCurrency(
                              minimumPayment,
                            )}`,
                          );
                          return;
                        }
                        if (
                          amount >
                          invoiceToPay.amount -
                            invoiceToPay.discount -
                            invoiceToPay.paidAmount
                        ) {
                          alert(
                            `Amount cannot be greater than the unpaid amount (${formatCurrency(
                              invoiceToPay.amount -
                                invoiceToPay.discount -
                                invoiceToPay.paidAmount,
                            )})`,
                          );
                          return;
                        }
                        closeCreate();
                      }}
                    >
                      {t("OTHER.save")}
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
      {/* ================================================================ */}

      {/* ====================== CONFIRMATION POPUP ===================== */}
      <Transition appear show={isOpen2} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={closeCreate2}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-25" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                  <Dialog.Title
                    as="h3"
                    className="text-lg font-medium leading-6 text-gray-900"
                  >
                    {t("LOGIN.confirm")}
                  </Dialog.Title>
                  <div>
                    <p className="text-sm text-gray-500 mt-2">
                      Apakah anda yakin ingin membayar tagihan ini?{" "}
                      {`(${formatCurrency(totalPayment)})`}
                    </p>
                  </div>
                  <div className="justify-center mt-4 flex gap-2">
                    <button
                      type="button"
                      style={{
                        backgroundColor: customApp?.app_secondary_accent_color,
                      }}
                      className={`inline-flex justify-center rounded-md border border-transparent  px-4 py-2 text-sm font-medium ${
                        isDarkColor(customApp.app_secondary_accent_color)
                          ? "text-white"
                          : "text-black"
                      }`}
                      onClick={() => closeCreate2()}
                    >
                      {t("OTHER.no")}
                    </button>
                    <button
                      type="button"
                      style={{
                        backgroundColor: customApp?.app_accent_color,
                      }}
                      className={`inline-flex justify-center rounded-md border border-transparent  px-4 py-2 text-sm font-medium ${
                        isDarkColor(customApp.app_accent_color)
                          ? "text-white"
                          : "text-black"
                      }`}
                      onClick={() => handleSubmit()}
                    >
                      {t("OTHER.yes")}
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
      {/* ================================================================ */}

      <div className="relative z-100 z-30 mb-4 mt-4 mx-4">
        <div className="rounded-2xl w-full bg-white flex flex-row p-3 justify-between shadow-psp-primary">
          <div className="flex flex-col">
            <h1 className="font-montserrat m-0 text-xs font-medium text-black text-start">
              {t("HOME.balance")}
            </h1>
            <p className="font-montserrat m-0 text-xl font-bold text-black text-start">
              {formatCurrency(balance)}
            </p>
          </div>
          <img src={dotBalance} alt="" />
        </div>
      </div>

      <div className="p-1 bg-white mt-2 mx-2 rounded-lg overflow-y-auto">
        <div className="text-left mb-2">
          <span className="font-montserrat m-0 text-sm font-normal text-psp-nav">
            Pilih Tagihan yang ingin anda bayar
          </span>
        </div>
        {detail.map((item: any) => (
          <div
            key={item.title}
            className={`font-montserrat w-full flex flex-col gap-4 p-2 justify-between rounded-lg mb-2 shadow-md ${
              tempPaymentList.find((i: any) => i.title === item.title)
                ? "bg-blue-50 border-blue-400"
                : "border-gray-300"
            }`}
          >
            <div className="flex gap-2 align-middle">
              <input
                disabled={
                  item.amount - item.discount - item.paidAmount === 0 ||
                  mustPaidOff
                }
                type="checkbox"
                checked={
                  !!tempPaymentList.find((i: any) => i.title === item.title) &&
                  tempPaymentList.find((i: any) => i.title === item.title)
                    ?.amount > 0
                }
                onChange={(e) => {
                  setInvoiceToPay(item);
                  setTempAmount(item.amount);
                  setTempPaymentList((prev: any) => {
                    const unpaidAmount =
                      item.amount - item.discount - (item.paidAmount || 0);
                    let minpay = minimumPayment;
                    if (minimumPaymentPosition === "ITEM") {
                      if (minimumPaymentType === "PERCENT")
                        minpay =
                          (location.state?.data.minimumPayment / 100) *
                          item.amount;
                      else if (minimumPaymentType === "CURRENCY")
                        minpay = location.state?.data.minimumPayment;
                    }
                    if (prev.some((i: any) => i.title === item.title)) {
                      // Remove item if already exists
                      return prev.filter((i: any) => i.title !== item.title);
                    } else {
                      if (
                        unpaidAmount < minpay &&
                        minimumPaymentPosition === "ITEM"
                      ) {
                        // Just add item with unpaidAmount, no popup, don't set amount to 0
                        return [
                          ...prev,
                          {
                            ...item,
                            amount: unpaidAmount,
                          },
                        ];
                      } else {
                        setIsOpen(true);
                        // Add item with amount 0, will be set in popup
                        return [
                          ...prev,
                          {
                            ...item,
                            amount: 0,
                          },
                        ];
                      }
                    }
                  });
                  // });
                }}
                className="w-5 h-5 text-blue-600"
              />
              <div className="font-montserrat m-0 text-xs font-bold text-black inline ml-2">
                {item.title}
              </div>
            </div>
            <div className="flex flex-col gap-1 w-full">
              <div className="flex justify-between w-full">
                <span className="text-xs">Nominal Tagihan</span>
                <span className="text-xs">{formatCurrency(item.amount)}</span>
              </div>
              <div className="flex justify-between w-full">
                <span className="text-xs">Diskon</span>
                <span className=" text-red text-xs">
                  {formatCurrency(item.discount)}
                </span>
              </div>
              <div className="flex justify-between w-full">
                <span className="text-xs">Total Tagihan</span>
                <span className="text-red text-xs">
                  {formatCurrency(item.amount - item.discount)}
                </span>
              </div>
              <div className="flex justify-between w-full  border-t border-psp-gray pt-2">
                <span className="text-xs">Tagihan Terbayar</span>
                <span className=" text-red text-xs">
                  {formatCurrency(item.paidAmount)}
                </span>
              </div>
              <div className="flex justify-between w-full border-b border-psp-gray pb-2">
                <span className="text-xs">Sisa Tagihan</span>
                <span className="font-bold text-red text-xs">
                  {formatCurrency(
                    item.amount - item.discount - item.paidAmount,
                  )}
                </span>
              </div>
              <div className="flex justify-between w-full">
                <span className="text-xs">Nominal yang akan dibayar</span>
                <span className="text-xs">
                  {formatCurrency(
                    tempPaymentList.find((i: any) => i.title === item.title)
                      ?.amount,
                  )}
                </span>
              </div>
            </div>
          </div>
        ))}
        <div className="flex justify-between items-center mt-4 border-t pt-3">
          <span className="font-montserrat m-0 text-sm font-normal text-psp-nav">
            Total Payment
          </span>
          <span className="font-montserrat text-sm font-normal text-psp-primary">
            {formatCurrency(
              tempPaymentList.reduce(
                (acc: number, curr: any) => acc + (curr.amount || 0),
                0,
              ),
            )}
          </span>
        </div>
      </div>
      <div className="p-3 bg-psp-primary fixed bottom-0 left-0 w-full">
        <button
          onClick={() => {
            if (minimumPaymentPosition === "SUMMARY") {
              if (
                totalPayment < minimumPayment &&
                minimumPayment <= unpaidAmount
              ) {
                alert(
                  `Total payment must be at least ${formatCurrency(
                    minimumPayment,
                  )}`,
                );
                return;
              }
              if (
                totalPayment < minimumPayment &&
                totalPayment < unpaidAmount
              ) {
                alert(
                  `Total payment must be at least ${formatCurrency(
                    unpaidAmount,
                  )}`,
                );
                return;
              }
              if (
                location.state?.data.minimumPayment === 0 &&
                totalPayment < 10000
              ) {
                alert(
                  `Total payment must be at least ${formatCurrency(10000)}`,
                );
                return;
              }
            }
            setIsOpen2(true);
          }}
          style={{
            backgroundColor: customApp?.app_accent_color,
            width: "100%",
          }}
          className={`px-2 py-2.5 rounded-lg font-bold text-xs active:bg-psp-active block w-full ${
            isDarkColor(customApp.app_accent_color)
              ? "text-white"
              : "text-black"
          }`}
        >
          {t("INVOICE.pay")}
        </button>
      </div>
    </div>
  );
};
export default ComponentInvoiceCreditPayment;
